<template>
    <v-dialog
        v-model="isOpen"
        max-width="1200"
    >
        <v-card>
            <v-card-title class="headline pb-10">
                Добавить пользователей?
            </v-card-title>
            <v-card-text> Выбран файл для выгрузки: {{file?file.name:''}}
                <b-field label="Файл" >
                    <b-upload v-model="file"
                              accept=".xlsx"
                              drag-drop>
                        <section class="section">
                            <div class="content has-text-centered">
                                <p>
                                    <b-icon
                                        icon="upload"
                                        size="is-large">
                                    </b-icon>
                                </p>
                                <span class="file-name" v-if="file" >
                            {{ file.name }}
                        </span>
                                <span v-else>
                            <p>Загрузить файл</p>
                            <p>В формате .xlsx</p>
                        </span>
                            </div>
                        </section>
                    </b-upload>
                </b-field>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="close()">Закрыть</v-btn>
                <v-btn text color="primary" @click="addUsers()">Добавить</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import OverlayLoader from '@/app/shared/components/app-loader/Loader';

export default {
    name: 'addUsersModal',
    components: {
        OverlayLoader,
    },
    props: [
        'params',
    ],
    data() {
        return {
          file: null,
        };
    },
    computed: {
        isOpen: {
            get(){
                return this.$store.getters.IS_ADD_USERS_MODAL_OPENED;
            },
            set(){
                this.$store.dispatch('ADD_USERS_MODAL', false);
            }
        },
    },
    methods: {
        close() {
            this.$store.dispatch('ADD_USERS_MODAL', false);
        },
        addUsers() {
            const formData = new FormData();
            formData.append('file', this.file);
            this.$store.dispatch('ADD_USERS', formData)
                .then(() => {
                    this.file = null;
                    this.$toast.success('Пользователи добавлены');
                    this.$store.dispatch('ADD_USERS_MODAL', false);
                    this.$store
                        .dispatch("GET_USERS", this.params)
                        .then((data) => {})
                        .catch((error) => {
                            this.$toaster.error("Неизвестная ошибка!");
                        });
                })
                .catch(() => {
                    this.$toast.error("Ошибка сервера");
                });
        },
    },
};
</script>
